
















import _ from 'lodash';
import mixins from 'vue-typed-mixins';
import { VueConstructor } from 'vue';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';
import { PageModeMixin } from '@/main/mixins/pageMode';

import { NAME, ZAKAZKA_DRUH, ZAKAZKA_DRUH_LOCALIZED,RequiredOrderType } from '../constants';

const STAV = {
	NABIDKA: {
		label: 'NabidkaPrp',
		labelKey: 'chkNabidky',
		disabled: new Set([ZAKAZKA_DRUH.GARANCE, ZAKAZKA_DRUH.PREVOD_ND, ZAKAZKA_DRUH.ZPETNY_ODKUP_ND]),
	},
	V_PRIPRAVE: {
		label: 'PripravaPrp',
		labelKey: 'chkVpriprave',
		disabled: new Set([ZAKAZKA_DRUH.PRODEJ_PULT, ZAKAZKA_DRUH.PREVOD_ND]),
	},
	OTEVRENA: {
		label: 'OtevrenePrp',
		labelKey: 'chkOtevrene',
		disabled: new Set([] as string[]),
	},
};
export default mixins(PageModeMixin).extend({
	name: 'CreateModal',
	provide(): {} {
		return { pageMode: this.pageMode };
	},
	props: {
		extraFilters: {
			type: Object,
			default: (): Object => ({}),
		},
	},
	data() {
		return {
			stav: STAV,
			visible: false,
			zakazkaDruh: null,
			zakazkaStav: STAV.OTEVRENA as typeof STAV.OTEVRENA | undefined,
			zakazkaStavLabel: STAV.OTEVRENA.label,
		};
	},
	computed: {
		loggedUser(): any {			
			return this.$store.state.loggedUser;			
		},
		modalLabel(): string {
			return this.LocalizeFormular('dlgZakazka');
		},
		zakazkaDruhy(): any {
			if(!this.dmsSys.IsAllContractTypePrp){
				return RequiredOrderType;
			}
			return ZAKAZKA_DRUH_LOCALIZED;
		},
		disableOk(): boolean {
			return !this.zakazkaDruh || !this.zakazkaStav;
		},
		druhDisabled(): boolean {
			return _.transform(this.zakazkaDruhy, (result: any, value: any, key: string) => {
				result[key] = this.zakazkaStav!.disabled.has(key);
			});
		},
		GetStav(): any {
			if (this.$store.state.loggedUser.DmsSys.IsPreparationActivePrp === false) {
				this.$delete(this.stav, 'V_PRIPRAVE');
				return this.stav;
			} else {
				return this.stav;
			}
		},				
	},
	watch: {
		zakazkaStavLabel(zakazkaStavLabel) {
			this.zakazkaStav = Object.values(this.stav).find((e) => e.label === zakazkaStavLabel);
			if (this.druhDisabled[this.zakazkaDruh!]) {
				this.zakazkaDruh = null;
			}
		},
	},
	methods: {
		createClickFun() {
			this.zakazkaDruh = this.loggedUser.UzivatelData.ZakazkaDruh;
			this.visible = true;
		},
		openCreate() {
			this.visible = false;
			openEdit(NAME, PageMode.CREATE, {
				props: true,
				filter: {
					ZakazkaDruh: this.zakazkaDruh,
					[this.zakazkaStav!.label]: true,
					...this.extraFilters,
				},
			});
		},
	},
});
